export default (log: any) => {
  if (log?.config?.headers?.Authorization) {
    delete log.config.headers.Authorization;
  }

  if (log?.config?.headers?.Cookie) {
    delete log.config.headers.Cookie;
  }

  return log;
};
